import React, { useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiDownload, FiSearch, FiSend } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { FaRegCopy, FaRegEnvelope } from "react-icons/fa";
import { BsFilePdf } from "react-icons/bs";
import { BiExport, BiImport } from "react-icons/bi";
import { FaBan } from "react-icons/fa6";
import { CSVLink } from "react-csv";
import oDayJs from "dayjs";
import { MdHistory } from "react-icons/md";
import { TbCertificate, TbFilterOff } from "react-icons/tb";
import { CFE_TYPES } from "./constants/CfeTypes";

import {
  ScreenContainer,
  Text,
  Input,
  Table,
  ComboBox,
  DateInput,
  PartnerSuggestions,
  Dropdown,
  ConfirmationModal,
  Button,
} from "components";

import { BUTTON_CONFIG } from "config/constants/Button";
import DocumentsLang from "./lang";
import {
  actionDocumentsChangeCurrency,
  actionDocumentsChangeDateFrom,
  actionDocumentsChangeDateTo,
  actionDocumentsChangeCode,
  actionDocumentsChangePage,
  actionDocumentsChangeStatus,
  actionDocumentsClean,
  actionDocumentsGetAll,
  actionDocumentsChangePartner,
  selectDocumentsState,
  actionDocumentsChangeTaxStatus,
  actionDocumentsChangeTaxNro,
  actionDocumentsSendToDGI,
  actionDocumentsSendToEmail,
  actionDocumentsExportToCsv,
  actionDocumentsDownload,
  actionDocumentsChangeType,
  actionDocumentsCancel,
  actionDocumentsCleanFilters,
  actionDocumentsImportFromFile,
  actionDocumentsGetSendHistory,
  actionDocumentsGetCaes,
} from "./redux";

import CustomModal from "components/CustomModal";
import { CastDate, CastFloat } from "utils/SharedUtils";
import { CURRENCY_VALUES } from "config/constants/Currency";
import { DOCUMENT_STATUS_CODES, DOCUMENT_STATUS_VALUES, DOCUMENT_TAX_STATUS_VALUES } from "./constants/Documents";
import { actionDocumentTypesGetAll, selectDocumentTypesState } from "pages/documentTypes";
import DropFile from "components/DropFile";
import { printDocument } from "utils/PrintUtils";

const DocumentsList = () => {
  const oDispatch = useDispatch();
  const oNavigator = useNavigate();
  const [oReSend, setReSend] = useState(null);
  const [bExport, setExport] = useState(false);
  const [bImport, setImport] = useState(false);
  const [sOpenRow, setOpenRow] = useState(null);
  const [oDownload, setDownload] = useState(null);
  const [oSendMail, setSendMail] = useState(null);
  const [oItemToConfirm, setItemToConfirm] = useState(null);
  const [oFile, setFile] = useState(null);
  const [oCancel, setCancel] = useState(null);
  //Historia de envios del documento
  const [oHistoryDoc, setHistoryDoc] = useState(null);
  const { aSendHistory, aCaes, bShowCaes } = useSelector(selectDocumentsState);

  const aNewButtons = [
    {
      onClick: () => onNavigate(),
      label: "Nuevo",
    },
    {
      onClick: () => onNavigate({ type: 1 }),
      label: "Venta Contado",
    },
    {
      onClick: () => onNavigate({ type: 2 }),
      label: "Venta Crédito",
    },
  ];

  const aOptionButtons = [
    {
      onClick: () => oDispatch(actionDocumentsCleanFilters()),
      label: "Limpiar Filtros",
    },
    {
      onClick: () => onShowCaes(),
      label: "CAEs",
    },
    {
      onClick: () => setImport(true),
      label: "Importar",
    },
    {
      onClick: () => setExport(true),
      label: "Exportar",
    },
    {
      onClick: () => onNavigate(),
      label: "Nuevo",
    },
    {
      onClick: () => onNavigate({ type: 1 }),
      label: "Venta Contado",
    },
    {
      onClick: () => onNavigate({ type: 2 }),
      label: "Venta Crédito",
    },
  ];

  const {
    aDocuments,
    nPage,
    nCode,
    sTaxNro,
    nPages,
    nRecords,
    bStatus,
    bStatusSend,
    dDateTo,
    dDateFrom,
    oStatus,
    oTaxStatus,
    oCurrency,
    oDataExport,
    sFile,
    oType,
  } = useSelector(selectDocumentsState);
  const { aDocumentTypes } = useSelector(selectDocumentTypesState);

  useEffect(() => {
    oDispatch(actionDocumentsGetAll());
    if (!aDocumentTypes || aDocumentTypes.length === 0) {
      oDispatch(actionDocumentTypesGetAll());
    }
  }, [nPage, nCode, sTaxNro, oStatus, oTaxStatus, oCurrency, oType, dDateFrom, dDateTo]);
  useEffect(() => {
    if (sFile) {
      printDocument(sFile, oDownload.id, () => {
        setDownload(null);
        oDispatch(actionDocumentsClean());
      });
    }
  }, [sFile]);

  useEffect(() => {
    if (bStatus || bStatusSend) {
      oDispatch(actionDocumentsGetAll());
      oDispatch(actionDocumentsClean());
    }
  }, [bStatus, bStatusSend]);

  const onChangeTimeout = (oState, oData) => {
    if (!oData) { return oState; }
    if (oState) { clearTimeout(oState); }
    return oData;
  };

  const [, setTimer] = useReducer(onChangeTimeout, null);

  const onChangePage = (nSelectedPage) => {
    oDispatch(actionDocumentsChangePage(nSelectedPage));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeCode = (sNewCode) => {
    oDispatch(actionDocumentsChangeCode(sNewCode.trim()));
    setTimer(setTimeout(() => {
      oDispatch(actionDocumentsChangePage(1));
      oDispatch(actionDocumentsGetAll());
    }, 800));
  };

  const onChangeTaxNro = (sNewCode) => {
    oDispatch(actionDocumentsChangeTaxNro(sNewCode.trim()));
    setTimer(setTimeout(() => {
      oDispatch(actionDocumentsChangePage(1));
      oDispatch(actionDocumentsGetAll());
    }, 800));
  };

  const onChangePartner = (oPartner) => {
    oDispatch(actionDocumentsChangePartner(oPartner));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeDateFrom = (dDate) => {
    oDispatch(actionDocumentsChangeDateFrom(oDayJs(dDate).toString()));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeDateTo = (dDate) => {
    oDispatch(actionDocumentsChangeDateTo(oDayJs(dDate).toString()));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeCurrency = (oCurrency) => {
    oDispatch(actionDocumentsChangeCurrency(oCurrency));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeType = (oType) => {
    oDispatch(actionDocumentsChangeType(oType));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeStatus = (oStatus) => {
    oDispatch(actionDocumentsChangeStatus(oStatus));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onChangeTaxStatus = (oStatus) => {
    oDispatch(actionDocumentsChangeTaxStatus(oStatus));
    oDispatch(actionDocumentsChangePage(1));
    oDispatch(actionDocumentsGetAll());
  };

  const onDownload = (event, oItem) => {
    event.stopPropagation();
    if (oItem.cae.status) return setDownload(oItem);
  };

  const onConfirmReSend = () => {
    oDispatch(actionDocumentsSendToDGI(oReSend.id));
    setReSend(null);
  };

  const onConfirmDownload = () => {
    oDispatch(actionDocumentsDownload(oDownload.id));
  };

  const onExportToCsv = () => {
    setExport(false);
    oDispatch(actionDocumentsExportToCsv());
  };

  const onReSendOrOpen = (event, oItem) => {
    event.stopPropagation();
    if (oItem.cae?.status) {
      if (sOpenRow === oItem.id)
        return setOpenRow(null);
      return setOpenRow(oItem.id);
    }
    setReSend(oItem);
  };

  const onCopy = (event, oItem) => {
    event.stopPropagation();
    onNavigate({ copy: oItem.id });
  };


  const onSendEmail = (event, oItem) => {
    setSendMail(false);
    oDispatch(actionDocumentsSendToEmail(oItem.id));
    event.stopPropagation();
  };

  const onView = (oItem) => oNavigator(`/documents/${oItem.id}`);
  const onNavigate = (oOptions) => oNavigator("/documents/new", { state: oOptions });

  const onCancel = (e, oItem) => {
    if (e) e.stopPropagation();
    if (!oCancel) return setCancel(oItem);
    oDispatch(actionDocumentsCancel(oCancel.id));
    setCancel(null);
  };

  const onShowHistory = (e, oItem) => {
    e.stopPropagation();
    setHistoryDoc(oItem);
    oDispatch(actionDocumentsGetSendHistory(oItem.id));
  };

  const onCloseHistory = () => {
    setHistoryDoc(null);
    oDispatch(actionDocumentsClean());
  };

  function onUpload(aFiles) {
    if (aFiles.length > 0) setFile(aFiles);
  }

  function onCloseUploadModal() {
    setFile(null);
    setImport(false);
  }

  function sendFile() {
    oDispatch(actionDocumentsImportFromFile(oFile));
    onCloseUploadModal();
  }

  const onShowCaes = () => {
    oDispatch(actionDocumentsGetCaes());
  };

  const onCloseCaes = () => {
    oDispatch(actionDocumentsClean());
  };


  return (
    <ScreenContainer>
      <section className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="ui-page-title">{DocumentsLang.Labels.listDocuments}</h1>
          <p className="ui-page-subtitle">{nRecords || 0} documentos con los filtros actuales</p>
        </div>
        <div className="hidden md:flex ui-toolbar">
          <Button
            label="Limpiar filtros"
            type={BUTTON_CONFIG.CLASS.SUCCESS}
            iconPosition={BUTTON_CONFIG.POSITION.LEFT}
            icon={<TbFilterOff size={15} />}
            onClick={() => oDispatch(actionDocumentsCleanFilters())}
          />
          <Button
            label="CAEs"
            onClick={onShowCaes}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
            iconPosition={BUTTON_CONFIG.POSITION.LEFT}
            icon={<TbCertificate size={15} />}
          />
          <Button
            label="Importar"
            onClick={() => setImport(true)}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
            iconPosition={BUTTON_CONFIG.POSITION.LEFT}
            icon={<BiImport size={15} />}
          />
          <Button
            label="Exportar"
            onClick={() => setExport(true)}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
            iconPosition={BUTTON_CONFIG.POSITION.LEFT}
            icon={<BiExport size={15} />}
          />
          <Dropdown
            label="Nuevo"
            items={aNewButtons}
            type={BUTTON_CONFIG.CLASS.PRIMARY}
          />
        </div>
        <div className="gap-2 flex md:hidden">
          <Dropdown
            label="Opciones"
            items={aOptionButtons}
            className="flex align-middle"
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
      </section>
      {/* Rediseño: filtros compactos en una fila (bajan de línea si no entran) */}
      <section className="ui-toolbar mt-4">
        <div className="relative w-full sm:w-44">
          <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none z-10" />
          <Input
            withoutClass
            value={nCode}
            floatLabel={false}
            onChange={onChangeCode}
            placeholder={DocumentsLang.Fields.number}
            className="ui-field-icon w-full"
          />
        </div>
        <div className="relative w-full sm:w-56">
          <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none z-10" />
          <PartnerSuggestions
            onSelect={onChangePartner}
            className="ui-field-icon w-full"
          />
        </div>
        <div className="relative w-full sm:w-44">
          <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none z-10" />
          <Input
            withoutClass
            value={sTaxNro}
            floatLabel={false}
            onChange={onChangeTaxNro}
            placeholder={DocumentsLang.Fields.taxOrInternalNumber}
            className="ui-field-icon w-full"
          />
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 dark:text-gray-400">Desde</span>
          <DateInput
            value={dDateFrom}
            onChange={onChangeDateFrom}
            placeholder={DocumentsLang.Labels.dateFrom}
            className="w-28"
          />
          <span className="text-xs text-gray-500 dark:text-gray-400">hasta</span>
          <DateInput
            value={dDateTo}
            onChange={onChangeDateTo}
            placeholder={DocumentsLang.Labels.dateTo}
            className="w-28"
          />
        </div>
        <ComboBox
          containerClassName="w-36"
          selected={oType}
          onChange={onChangeType}
          options={aDocumentTypes}
          emptyLabel={DocumentsLang.Fields.type}
        />
        <ComboBox
          containerClassName="w-32"
          selected={oStatus}
          onChange={onChangeStatus}
          emptyLabel={DocumentsLang.Fields.status}
          options={DOCUMENT_STATUS_VALUES}
        />
        <ComboBox
          containerClassName="w-36"
          selected={oTaxStatus}
          onChange={onChangeTaxStatus}
          options={DOCUMENT_TAX_STATUS_VALUES}
          emptyLabel={DocumentsLang.Fields.taxStatus}
        />
        <ComboBox
          containerClassName="w-28"
          selected={oCurrency}
          onChange={onChangeCurrency}
          emptyLabel={DocumentsLang.Fields.currency}
          options={CURRENCY_VALUES}
        />
      </section>
      <section className="py-4">
        <Table>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="w-8" />
              <Table.Col scope="col" className="px-3 py-2">
                {DocumentsLang.Fields.code}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 hidden md:table-cell">
                {DocumentsLang.Fields.date}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2">
                {DocumentsLang.Fields.headline}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 hidden md:table-cell">
                {DocumentsLang.Fields.typeDoc}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-right hidden md:table-cell">
                {DocumentsLang.Fields.currency} / {DocumentsLang.Fields.total}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2">
                {DocumentsLang.Fields.taxStatus}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aDocuments?.length > 0 ? (
              aDocuments.map((oItem, index) => (
                <React.Fragment key={`${oItem.id}_${index}`}>
                  <Table.Row onClick={() => onView(oItem)} className="cursor-pointer">
                    <Table.Col scope="row" className="pl-3">
                      {oItem.status !== DOCUMENT_STATUS_CODES.CANCELLED &&
                        <button type="button" title="Anular" className="flex text-gray-300 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400" onClick={e => onCancel(e, oItem)}>
                          <FaBan size={14} />
                        </button>}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-medium text-gray-800 dark:text-white whitespace-nowrap">
                      {oItem.code}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal text-gray-500 dark:text-gray-400 whitespace-nowrap hidden md:table-cell">
                      {CastDate(oItem.date)}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal">
                      {oItem.partner?.name || "-"}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal text-gray-500 dark:text-gray-400 hidden md:table-cell">
                      {oItem?.type?.name}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal text-right tabular-nums whitespace-nowrap hidden md:table-cell">
                      {oItem?.currency?.code || "S/M"} {CastFloat(oItem.total).toFixed(0)}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal">
                      {oItem.status === DOCUMENT_STATUS_CODES.CANCELLED
                        ? <span className="ui-pill bg-red-50 text-red-700 dark:bg-red-900/40 dark:text-red-300">Anulado</span>
                        : oItem.cae?.status
                          ? <span className="ui-pill bg-green-50 text-green-700 dark:bg-green-900/40 dark:text-green-300">Con CAE</span>
                          : <span className="ui-pill bg-yellow-50 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300">Sin CAE</span>}
                    </Table.Col>
                    <Table.Col className="px-3 py-2 font-normal">
                      <div className="flex items-center justify-end gap-3 text-gray-400 dark:text-gray-500">
                        <MdHistory
                          size={16}
                          title="Historial de envíos"
                          className="cursor-pointer hover:text-primary-600 dark:hover:text-primary-300"
                          onClick={e => onShowHistory(e, oItem)}
                        />
                        {oItem.cae?.status
                          ? <BsFilePdf size={15} title="Ver CAE" className="cursor-pointer hover:text-green-600 dark:hover:text-green-400" onClick={e => onReSendOrOpen(e, oItem)} />
                          : <FiSend size={15} title="Reenviar a DGI" className="cursor-pointer text-yellow-500 hover:text-yellow-600" onClick={e => onReSendOrOpen(e, oItem)} />
                        }
                        <FaRegCopy size={14} title="Copiar" className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200" onClick={e => onCopy(e, oItem)} />
                        <FaRegEnvelope size={14} title="Enviar por mail" className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200" onClick={e => onSendEmail(e, oItem)} />
                      </div>
                    </Table.Col>
                  </Table.Row>
                  {
                    sOpenRow === oItem.id &&
                    <Table.Row>
                      <Table.Col className="px-3 py-2 font-normal text-gray-500" colSpan='3'>
                        CAE: <span className="text-gray-800 dark:text-white">{oItem.cae.number}</span>
                      </Table.Col>
                      <Table.Col className="px-3 py-2 font-normal" colSpan='3'>
                        <a
                          className="text-primary-600 hover:underline dark:text-primary-300"
                          onClick={(e) => e.stopPropagation()}
                          target="_blank"
                          rel="noreferrer"
                          href={oItem.cae?.link}
                        >
                          Verificar en DGI
                        </a>
                      </Table.Col>
                      <Table.Col className="px-3 py-2 font-normal" colSpan='2'>
                        <button type="button" title="Descargar" className="flex ml-auto text-gray-500 hover:text-primary-600" onClick={(e) => onDownload(e, oItem)}>
                          <FiDownload size={16} />
                        </button>
                      </Table.Col>
                    </Table.Row>
                  }
                </React.Fragment>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-3 py-6 font-normal text-center text-gray-500" colSpan={8}>
                  No se encontraron documentos con los filtros indicados
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row isHeaderOrFooter>
              <Table.Col colSpan="8" className="px-3 py-2 text-center md:hidden">
                <Table.Pagination total={nPages} page={nPage} onChange={onChangePage} records={nRecords} />
              </Table.Col>
            </Table.Row>
            <Table.Row isHeaderOrFooter>
              <Table.Col colSpan="3" className="px-3 py-2 font-normal text-left">
                Total: {nRecords || "0"}
              </Table.Col>
              <Table.Col colSpan="5" className="px-3 py-2 text-right hidden md:table-cell">
                <Table.Pagination total={nPages} page={nPage} onChange={onChangePage} records={nRecords} />
              </Table.Col>
            </Table.Row>
          </Table.Footer>
        </Table>
      </section>
      <ConfirmationModal
        show={!!oReSend}
        title="Re enviar documento"
        onConfirm={onConfirmReSend}
        onClose={() => setReSend(null)}
        question={`Está seguro que quiere re envíar el documento "${oReSend?.code}"`}
        message="Se re enviará el documento a DGI para ser facturado"
      />
      <ConfirmationModal
        show={!!oDownload}
        title="Visualizar documento"
        onConfirm={onConfirmDownload}
        onClose={() => setDownload(null)}
        question={`Está seguro que quiere descargar el documento "${oDownload?.code}"`}
      />
      <ConfirmationModal
        show={bExport}
        onConfirm={onExportToCsv}
        title="Exportar documentos"
        onClose={() => setExport(false)}
        question="Está seguro que quiere exportar la lista de documentos"
        message="Se generará un archivo csv de los documentos que apliquen al filtro actual"
      />

      <CustomModal show={!!oDataExport} title="Archivo cargado correctamente" onClose={() => oDispatch(actionDocumentsClean())}>
        <p className="text-center">
          {
            oDataExport?.records?.length > 0
              ? "Hemos generado y cargado correctamente su archivo, descargarlo desde aquí"
              : "No se encontraron documentos para el filtro aplicado"
          }
        </p>
        <div className="mt-5 text-center md:text-right flex justify-end gap-4">
          <Button
            label="Cerrar"
            type={BUTTON_CONFIG.CLASS.DANGER}
            size={BUTTON_CONFIG.SIZE.SM}
            onClick={() => oDispatch(actionDocumentsClean())}
          />
          {
            oDataExport?.records?.length > 0 &&
            <CSVLink
              className="m-0 p-0"
              data={oDataExport?.records}
              headers={oDataExport?.headers}
              onClick={() => oDispatch(actionDocumentsClean())}
              title={`Documentos ${oDayJs().format("DD-MM-YYYY")}`}
              filename={`Documentos ${oDayJs().format("DD-MM-YYYY")}`}
            >
              <Button
                label="Descargar"
                size={BUTTON_CONFIG.SIZE.SM}
                type={BUTTON_CONFIG.CLASS.SUCCESS}
              />
            </CSVLink>
          }
        </div>
      </CustomModal>
      <CustomModal show={bImport} title="Importar documentos" onClose={() => setImport(false)} className="!overflow-hidden">
        <Text className="text-center mb-4">
          Arrastre o seleccione el archivo que desea importar
        </Text>
        <DropFile
          file={oFile}
          accept={".json"}
          upload={onUpload}
        />
        {/* <input type="file" name="file" onChange={e => setFile(e.target.files)} /> */}
        <div className=" mt-5 text-center md:text-right flex justify-end gap-4">
          <Button
            label="Cerrar"
            onClick={onCloseUploadModal}
            size={BUTTON_CONFIG.SIZE.SM}
            type={BUTTON_CONFIG.CLASS.DANGER}
          />
          <Button
            label="Enviar"
            disabled={!oFile}
            onClick={sendFile}
            size={BUTTON_CONFIG.SIZE.SM}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
      </CustomModal>
      <CustomModal
        show={bShowCaes}
        title="Estado de CAEs"
        onClose={onCloseCaes}
      >
        <div className="overflow-x-auto max-h-96">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-4 py-3">Tipo</th>
                <th className="px-4 py-3">Serie</th>
                <th className="px-4 py-3 text-center">Estado</th>
                <th className="px-4 py-3">Emisión</th>
                <th className="px-4 py-3">Vencimiento</th>
                <th className="px-4 py-3 text-right">Último nro</th>
                <th className="px-4 py-3 text-right">Hasta nro</th>
                <th className="px-4 py-3 text-right">Usados</th>
              </tr>
            </thead>
            <tbody>
              {aCaes?.length > 0
                ? aCaes.map((oCae, nIndex) => {
                  const bActivo = oCae.estado === "1";
                  return (
                    <tr key={nIndex} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="px-4 py-3">
                        <span className="font-medium text-gray-900 dark:text-white">
                          {CFE_TYPES[+oCae.tipo] || `Tipo ${oCae.tipo}`}
                        </span>
                        <span className="block text-xs text-gray-400">{oCae.tipo}</span>
                      </td>
                      <td className="px-4 py-3">{oCae.serie?.trim() || "-"}</td>
                      <td className="px-4 py-3 text-center">
                        <span className={`px-2 py-1 rounded text-xs font-medium ${bActivo ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                          {bActivo ? "Activo" : "Inactivo"}
                        </span>
                      </td>
                      <td className="px-4 py-3">{oCae.femision || "-"}</td>
                      <td className="px-4 py-3">{oCae.fvto || "-"}</td>
                      <td className="px-4 py-3 text-right">{oCae.ultnro || "0"}</td>
                      <td className="px-4 py-3 text-right">{oCae.hnro || "0"}</td>
                      <td className="px-4 py-3 text-right">{oCae.cantusados || "0"}</td>
                    </tr>
                  );
                })
                : <tr>
                  <td colSpan="8" className="px-4 py-10 text-center text-gray-400">
                    No se encontraron CAEs
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="mt-5 flex justify-end">
          <Button
            label="Cerrar"
            onClick={onCloseCaes}
            size={BUTTON_CONFIG.SIZE.SM}
            type={BUTTON_CONFIG.CLASS.DANGER}
          />
        </div>
      </CustomModal>

      <ConfirmationModal
        show={!!oCancel}
        onConfirm={onCancel}
        title="Cancelar documento"
        onClose={() => setCancel(null)}
        question={`Está seguro que desea anular el documento "${oCancel?.code}"`}
      />

      <CustomModal
        show={!!oHistoryDoc}
        title={`Historial de envíos - ${oHistoryDoc?.code}`}
        onClose={onCloseHistory}
      >
        <div className="overflow-x-auto max-h-96">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-4 py-3">Fecha</th>
                <th className="px-4 py-3">Estado</th>
                <th className="px-4 py-3">Resultado</th>
                <th className="px-4 py-3">Serie</th>
                <th className="px-4 py-3">Nro</th>
                <th className="px-4 py-3">Link</th>
              </tr>
            </thead>
            <tbody>
              {aSendHistory?.length > 0
                ? aSendHistory.map((oEnvio, nIndex) => (
                  <tr key={nIndex} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <td className="px-4 py-3">{oEnvio.envId?.toString().substring(0, 8)}</td>
                    <td className="px-4 py-3">{oEnvio.envEstado}</td>
                    <td className="px-4 py-3">{oEnvio.envResultado}</td>
                    <td className="px-4 py-3">{oEnvio.serie || "-"}</td>
                    <td className="px-4 py-3">{oEnvio.nro || "-"}</td>
                    <td className="px-4 py-3">
                      {oEnvio.envLink
                        ? <a href={oEnvio.envLink} target="_blank" rel="noreferrer" className="text-blue-500 underline">Ver</a>
                        : "-"}
                    </td>
                  </tr>
                ))
                : <tr>
                  <td colSpan="6" className="px-4 py-10 text-center text-gray-400">
                    No hay envíos registrados para este documento
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="mt-5 flex justify-end">
          <Button
            label="Cerrar"
            onClick={onCloseHistory}
            size={BUTTON_CONFIG.SIZE.SM}
            type={BUTTON_CONFIG.CLASS.DANGER}
          />
        </div>
      </CustomModal>

      <CustomModal
        show={!!oHistoryDoc}
        title={`Historial de envíos - ${oHistoryDoc?.code}`}
        onClose={onCloseHistory}
      >
        <div className="overflow-x-auto max-h-96">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-4 py-3">Fecha y hora</th>
                <th className="px-4 py-3">Estado</th>
                <th className="px-4 py-3">Tipo</th>
                <th className="px-4 py-3">Serie</th>
                <th className="px-4 py-3">Nro</th>
              </tr>
            </thead>
            <tbody>
              {aSendHistory?.length > 0
                ? aSendHistory.map((oEnvio, nIndex) => {
                  const sEnvId = oEnvio.envId?.toString() || "";
                  const sFecha = `${sEnvId.substring(6, 8)}/${sEnvId.substring(4, 6)}/${sEnvId.substring(0, 4)}`;
                  const sHora = `${sEnvId.substring(8, 10)}:${sEnvId.substring(10, 12)}:${sEnvId.substring(12, 14)}`;
                  const bOk = oEnvio.envEstado === "Enviado OK";
                  return (
                    <tr key={nIndex} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="px-4 py-3">{sFecha} {sHora}</td>
                      <td className={`px-4 py-3 font-bold ${bOk ? "text-green-500" : "text-red-500"}`}>
                        {oEnvio.envEstado}
                      </td>
                      <td className="px-4 py-3">{oEnvio.tipo || "-"}</td>
                      <td className="px-4 py-3">{oEnvio.serie?.trim() || "-"}</td>
                      <td className="px-4 py-3">{oEnvio.nro || "-"}</td>
                    </tr>
                  );
                })
                : <tr>
                  <td colSpan="5" className="px-4 py-10 text-center text-gray-400">
                    No hay envíos registrados para este documento
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="mt-5 flex justify-end">
          <Button
            label="Cerrar"
            onClick={onCloseHistory}
            size={BUTTON_CONFIG.SIZE.SM}
            type={BUTTON_CONFIG.CLASS.DANGER}
          />
        </div>
      </CustomModal>
    </ScreenContainer>
  );
};

export default DocumentsList;
